import React from "react";

const ErrorPage = () => {
    return (
        <div className="error-page text-center py-5">
            <h1>404</h1>
            <p>Sorry, the page you're looking for doesn't exist.</p>
            <a href="/" className="btn btn-primary">Go Back to Home</a>
        </div>
    );
};

export default ErrorPage;
